/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
    CriteriaToJSONTyped,
} from './Criteria';

/**
 * 
 * @export
 * @interface BulkUpdateCriteriaRequest
 */
export interface BulkUpdateCriteriaRequest {
    /**
     * 
     */
    criterion: Criteria;
}

/**
 * Check if a given object implements the BulkUpdateCriteriaRequest interface.
 */
export function instanceOfBulkUpdateCriteriaRequest(value: object): value is BulkUpdateCriteriaRequest {
    if (!('criterion' in value) || value['criterion'] === undefined) return false;
    return true;
}

export function BulkUpdateCriteriaRequestFromJSON(json: any): BulkUpdateCriteriaRequest {
    return BulkUpdateCriteriaRequestFromJSONTyped(json, false);
}

export function BulkUpdateCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateCriteriaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'criterion': CriteriaFromJSON(json['criterion']),
    };
}

export function BulkUpdateCriteriaRequestToJSON(json: any): BulkUpdateCriteriaRequest {
    return BulkUpdateCriteriaRequestToJSONTyped(json, false);
}

export function BulkUpdateCriteriaRequestToJSONTyped(value?: BulkUpdateCriteriaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criterion': CriteriaToJSON(value['criterion']),
    };
}

